// extracted by mini-css-extract-plugin
export default {"formCard":"formCard__Kyi5w","verifyBtn":"verifyBtn__1yhU-","inputCardWrapperMobile":"inputCardWrapperMobile__1h7eE","countryCode":"countryCode__3n7g9"};